import { render, staticRenderFns } from "./OpenserveMplsOverFibreService.vue?vue&type=template&id=10b85d56&"
import script from "./OpenserveMplsOverFibreService.vue?vue&type=script&lang=js&"
export * from "./OpenserveMplsOverFibreService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports